import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import MatchingGifts from "./App/MatchingGifts";
import { store } from "shared/store";

export default (props) => (
  <Provider store={store}>
    <BrowserRouter>
      <MatchingGifts {...props} />
    </BrowserRouter>
  </Provider>
);
